{
  "dashboard": "Dashibodi ya Mkaguzi",
  "assignments": "Kazi",
  "reviews": "Mapitio",
  "sidebar": {
    "dashboard": "Dashibodi",
    "assigned_projects": "Miradi Iliyopangwa",
    "verification_reports": "Ripoti za Uthibitishaji",
    "validation_schedule": "Ratiba ya Uthibitishaji",
    "settings": "Mipangilio"
  },
  "dashboard_page": {
    "title": "Dashibodi ya Mkaguzi",
    "subtitle": "Simamia uthibitishaji wa miradi na ripoti za uthibitishaji",
    "stats": {
      "assigned_projects": "Miradi Iliyopangwa",
      "pending_reviews": "Mapitio Yanayosubiri",
      "completed_reports": "Ripoti Zilizokamilishwa",
      "validation_score": "Alama ya Uthibitishaji"
    },
    "assigned_projects": {
      "title": "Miradi Iliyopangwa",
      "view_all": "Tazama Zote",
      "validation_due": "Uthibitishaji Unakaribia",
      "in_progress": "Inaendelea",
      "completed": "Imekamilika",
      "due": "Mwisho",
      "started": "Imeanza"
    },
    "validation_status": {
      "title": "Hali ya Uthibitishaji",
      "projects_validated": "Miradi Iliyothibitishwa",
      "reports_submitted": "Ripoti Zilizowasilishwa",
      "compliance_rate": "Kiwango cha Uzingatiaji"
    },
    "recent_reports": {
      "title": "Ripoti za Hivi Karibuni za Uthibitishaji",
      "upload_report": "Pakia Ripoti",
      "project": "Mradi",
      "type": "Aina",
      "status": "Hali",
      "date": "Tarehe",
      "actions": "Vitendo",
      "validation_report": "Ripoti ya Uthibitishaji",
      "verification_report": "Ripoti ya Uhakiki",
      "approved": "Imeidhinishwa",
      "under_review": "Inakaguliwa"
    },
    "quick_actions": {
      "title": "Vitendo vya Haraka",
      "upload_report": {
        "title": "Pakia Ripoti",
        "description": "Wasilisha ripoti ya uthibitishaji"
      },
      "schedule_validation": {
        "title": "Panga Uthibitishaji",
        "description": "Weka tathmini ya mradi"
      },
      "update_declaration": {
        "title": "Sasisha Tamko",
        "description": "Badilisha taarifa ya kutopendelea"
      }
    }
  },
  "register_page": {
    "breadcrumb": {
      "home": "Nyumbani",
      "registration": "Usajili",
      "auditor_registration": "Usajili wa Mkaguzi"
    },
    "hero": {
      "title": "Usajili wa Mkaguzi",
      "subtitle": "Idhini ya Chombo Maalum cha Uendeshaji (DOE)",
      "registration_fee": "Ada ya Usajili: $3,000.00"
    },
    "form": {
      "title": "Fomu ya Usajili wa DOE",
      "subtitle": "Jaza sehemu zote zinazohitajika ili kusajiliwa kama Chombo Maalum cha Uendeshaji",
      "step_progress": "Hatua ya 1 kati ya 3",
      "entity_information": {
        "title": "Taarifa za Chombo",
        "entity_name": "Jina la Chombo",
        "entity_name_placeholder": "Ingiza jina la kisheria la chombo",
        "country": "Nchi ya Kuundwa",
        "select_country": "Chagua Nchi",
        "registration_number": "Nambari ya Usajili",
        "registration_number_placeholder": "Ingiza nambari ya usajili wa kisheria",
        "contact_email": "Barua pepe ya Mawasiliano",
        "contact_email_placeholder": "mfano: mawasaliano{'@'}chombo.com",
        "phone_number": "Nambari ya Simu",
        "phone_number_placeholder": "mfano: +1 (555) 123-4567",
        "website": "Tovuti",
        "website_placeholder": "mfano: https://www.chombo.com",
        "address": "Anwani ya Mahali",
        "address_placeholder": "Ingiza anwani kamili ya mahali"
      },
      "accreditation_details": {
        "title": "Maelezo ya Idhini",
        "accreditation_body": "Chombo cha Kutoa Idhini",
        "select_body": "Chagua Chombo cha Kutoa Idhini",
        "accreditation_number": "Nambari ya Idhini",
        "accreditation_number_placeholder": "Nambari ya cheti cha idhini",
        "valid_until": "Idhini Halali Hadi",
        "iso_standard": "Kiwango cha ISO",
        "select_iso": "Chagua Kiwango cha ISO"
      },
      "sectoral_scope": {
        "title": "Uteuzi wa Wigo wa Kisekta",
        "info_title": "Chagua Maeneo Yako ya Utaalam",
        "info_description": "Chagua wigo wote wa kisekta ambapo chombo chako kina idhini na utaalam wa kuthibitisha miradi ya mikopo ya kaboni.",
        "energy_renewable": "Nishati (Inayoweza Kurejeshwa)",
        "energy_renewable_desc": "Jua, Upepo, Maji",
        "energy_efficiency": "Ufanisi wa Nishati",
        "energy_efficiency_desc": "Majengo, Viwanda",
        "transport": "Usafiri",
        "transport_desc": "Mabadiliko ya modi, Ufanisi",
        "manufacturing": "Utengenezaji",
        "manufacturing_desc": "Uboreshaji wa michakato",
        "chemical_industry": "Sekta ya Kemikali",
        "chemical_industry_desc": "Uzalishaji wa hewa chafu",
        "construction": "Ujenzi",
        "construction_desc": "Vifaa, Mbinu",
        "mining_mineral": "Uchimbaji Madini/Madini",
        "mining_mineral_desc": "Uchimbaji, Usindikaji",
        "metal_production": "Uzalishaji wa Metali",
        "metal_production_desc": "Chuma, Aluminiamu",
        "fugitive_emissions": "Uzalishaji wa Hewa Uliotoroka",
        "fugitive_emissions_desc": "Mafuta, Gesi, Makaa ya Mawe",
        "solvents": "Viyeyusho",
        "solvents_desc": "Matumizi ya viwandani",
        "waste_management": "Usimamizi wa Taka",
        "waste_management_desc": "Utupaji, Matibabu",
        "afolu": "AFOLU",
        "afolu_desc": "Kilimo, Misitu",
        "chemical_industry_placeholder": "mfano: Uzalishaji wa asidi ya nitriki",
        "construction_placeholder": "mfano: Uzalishaji wa saruji",
        "mining_mineral_placeholder": "mfano: Uchimbaji wa makaa ya mawe",
        "metal_production_placeholder": "mfano: Uzalishaji wa chuma na chuma",
        "fugitive_emissions_placeholder": "mfano: Methani kutoka gesi asilia",
        "solvents_placeholder": "mfano: Utumiaji wa rangi",
        "waste_management_placeholder": "mfano: Urejeshaji wa gesi ya jaa"
      },
      "documents": {
        "title": "Nyaraka Zinazohitajika",
        "accreditation_certificate": "Cheti cha Idhini",
        "risk_framework": "Mfumo wa Usimamizi wa Hatari",
        "declaration_impartiality": "Tamko la Kutopendelea",
        "upload_instructions": "Bofya ili kupakia au buruta na kuangusha",
        "file_requirements": "PDF, upeo 10MB"
      },
      "declarations": {
        "title": "Matamko na Masharti"
      }
    }
  }
}